import type { SVGProps } from 'react';
export {
  ArrowRight,
  Bell,
  Briefcase,
  Building2,
  Check,
  ChevronLeft,
  CircleUserRound,
  Ellipsis,
  Hourglass,
  LayoutGrid,
  ChartLine,
  List,
  Lock,
  Mail,
  MessageSquare,
  Phone,
  Plus,
  Search,
  Settings,
  SquareCheck,
  StickyNote,
  TriangleAlert,
  Users,
  Wallet,
  X,
  Home,
  Target,
  Clock,
  BookOpen,
  Plug,
  Megaphone,
  Package,
  Gauge,
} from 'lucide-react';

/** The AI symbol: eight-ray asterisk (LG 5). No sparkles, no gradients. */
export function AiAsterisk({ size = 14, strokeWidth = 2.4, ...rest }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      {...rest}
    >
      <path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4" />
    </svg>
  );
}
